import React, { FC, ReactElement } from 'react';
import { ObjectSchema } from 'yup';

import { ApplicantTypes } from '@interfaces/userApplication/userApplication';
import ProEmploymentStatusContainer from '../proEmploymentStatus/ProEmploymentStatusContainer';
import BasicInvestorTypePageContainer from '../basicInvestorTypePage/BasicInvestorTypePageContainer';

import { Maybe } from '@interfaces/graphql-typings';

const AdditionalInformationContainer: FC<{
  applicantType: Maybe<ApplicantTypes>;
  isLoading: boolean;
  isRobot: boolean;
  validationSchema: ObjectSchema<any>;
}> = ({ applicantType, validationSchema, isLoading, isRobot }): ReactElement => {
  if (applicantType === ApplicantTypes.basic) {
    return (
      <BasicInvestorTypePageContainer
        validationSchema={validationSchema}
        isLoading={isLoading}
        isRobot={isRobot}
      />
    );
  }
  return (
    <ProEmploymentStatusContainer
      validationSchema={validationSchema}
      isLoading={isLoading}
      isRobot={isRobot}
    />
  );
};

export default AdditionalInformationContainer;
